import axios from 'axios';
import { API_URL } from '../config/constant';

const api = axios.create({
  // baseURL: `${
  //   process.env.NODE_ENV === 'development'
  //     ? process.env.REACT_APP_API_URL
  //     : API_URL
  // }/api/v1`,
  baseURL: `${process.env.REACT_APP_API_URL || API_URL}/api/v1`,
});

const apiV2 = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || API_URL}/api/v2`,
});

if (process.env.ATS_API_KEY === null) {
  // throw new Error('ATS_API_KEY environment variable is not defined');
  console.log('ATS_API_KEY environment variable is not defined');
}

const headersCityState = {
  'X-Api-Key': process.env.ATS_API_KEY,
  'Content-Type': 'application/json',
};

const apiCityState = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || API_URL}/api/v1`,
  headers: headersCityState,
});

export { apiV2 };

export { apiCityState };

export default api;
